export default __webpack_public_path__ + "static/media/bg-home-2.57596b67.jpg";